import { Component, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

@Component({
  template: ''
})
// tslint:disable-next-line:component-class-suffix
export class Unsubscribe implements OnDestroy {

  private subscriptions: Subscription[] = [];

  public set subscribeTo(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
